export const inputs = {
  type_collapse: require('../forms/_sub/fieldsets/collapsable'),
  type_textarea: require('./textarea/textarea'),
  type_text: require('./text/text'),
  type_date: require('./date/date'),
  type_number: require('./number/number'),
  type_checkbox: require('./checkbox/checkbox'),
  type_password: require('./password/password'),
  type_radio: require('./radio/radio'),
  type_button: require('./buttons/button'),
  type_hidden: require('./hidden/hidden'),
  type_url: require('./url/url'),
  type_checkboxGroup: require('./checkbox/group'),
  type_duplicate: require('./text/duplicate'),
  type_email: require('./email/email'),
  type_select: require('./selects/custom-select'),
  type_autocomplete: require('./selects/autocomplete'),
  type_multiText: require('./textarea/multiText'),
  type_buttonGroup: require('./buttons/group'),
  type_group: require('./text/group/group'),
  type_addressLookup: require('./address/lookup'),
  type_assetUpload: require('./file/upload'),
  type_fieldset: require('../forms/_sub/fieldsets/standard'),
  type_hide: require('../containers/hide'),
  type_priceTable: require('../tables/pricing'),
  type_multipart: require('../forms/_sub/multipart'),
  type_singlepart: require('../forms/_sub/singlepart'),
  type_navBar: require('../nav/navbar'),
  type_tiles: require('../nav/tiles'),
  type_splitField: require('./dynamic/split'),
  type_dataTable: require('../tables/datagrid'),
  type_interests: require('./text/group/interests'),
  type_htmlTable: require('../tables/dataList'),
  type_barChart: require('../charts/bar'),
  type_carousel: require('../widgets/carousel'),
  type_upload: require('./file/file'),
  type_asset: require('./file/assets'),
  type_linkButton: require('./buttons/link')
}

export const dynamic = {
  input: require('./dynamic/input')
}



// WEBPACK FOOTER //
// ./src/components/inputs/index.js